import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  inject,
  OnInit,
} from '@angular/core';
import { BackdropComponent } from '../backdrop/backdrop.component';
import { ButtonComponent } from '../button/button.component';
import { AsyncPipe, NgOptimizedImage } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { StateService } from '../../services/state.service';
import { LocaleData, LocaleMap } from '../../helpers/locale-map';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { TranslocoDirective } from '@jsverse/transloco';
import { LanguagePopupService } from './language-popup.service';

@Component({
  selector: 'app-language-popup',
  imports: [
    BackdropComponent,
    ButtonComponent,
    NgOptimizedImage,
    NgSelectModule,
    ReactiveFormsModule,
    SvgIconComponent,
    TranslocoDirective,
    AsyncPipe,
  ],
  templateUrl: './language-popup.component.html',
  styleUrl: './language-popup.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LanguagePopupComponent implements OnInit {
  private readonly stateService = inject(StateService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly cdr = inject(ChangeDetectorRef);
  private originalActiveLocale = '';

  readonly localeControl = new FormControl();
  readonly localeLabelFor = 'languagePopupControl';
  readonly languagePopupService = inject(LanguagePopupService);

  readonly availableLocales = this.stateService.availableLocales
    .map(
      (locale) =>
        ({ locale, localeData: LocaleMap[locale] }) as {
          locale: string;
          localeData?: (typeof LocaleMap)['locale'];
        },
    )
    .filter(({ locale, localeData }) => {
      if (!localeData) {
        console.warn(`Missing data for ${locale} locale`);
      }

      return !!localeData;
    }) as { locale: string; localeData: LocaleData }[];

  ngOnInit() {
    this.stateService.activeLocale$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((activeLocale) => {
        this.originalActiveLocale = activeLocale;
        this.localeControl.setValue(activeLocale);
        this.cdr.markForCheck();
      });
  }

  saveLocale(): void {
    this.languagePopupService.onClose();

    if (this.originalActiveLocale === this.localeControl.value) {
      return;
    }

    window.location.href = `/${this.localeControl.value}`;
  }

  close(): void {
    this.languagePopupService.onClose();
  }
}
